import React, { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";

const Profile = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isAddingCard, setIsAddingCard] = useState(false);
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvv, setCvv] = useState("");
  const user = useSelector((state) => state.auth.user);

  const handleEditProfile = () => {
    setIsEditing(true);
  };

  const handleSaveChanges = () => {
    // Here you would typically update the user's information in the backend
    setIsEditing(false);
  };

  const handleAddCard = () => {
    setIsAddingCard(true);
  };

  const handleSaveCard = () => {
    // Here you would typically save the card information in the backend
    setIsAddingCard(false);
  };

  const formatDate = (isoDateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(isoDateString);
    return date.toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    setEmail(user?.email);
  }, [user]);

  return (
    <div className="container mx-auto px-6 py-12 min-h-screen mt-10 lg:mt-20">
      <div className="bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-lg shadow-lg min-w-[50%] p-8 max-w-3xl">
        <div className="flex items-center">
          <div className="w-20 h-20 min-w-20 flex justify-center items-center  bg-slate-300 rounded-full shadow-md border-4 border-white overflow-hidden">
            <FaUser className="h-10 w-10 text-slate-500" />
          </div>
          <div className="ml-6">
            <h2 className="text-2xl font-bold text-gray-800">{user?.name}</h2>
            <p className="text-gray-600">{user?.role}</p>
            <p className="text-sm text-gray-500">
              Joined {formatDate(user?.created_at)}
            </p>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-200 pt-8">
          <h3 className=" font-semibold text-gray-800 mb-4">
            Contact Information
          </h3>
          <p className="text-gray-700">
            <span className="font-semibold">Email: </span>
            {user?.email}
          </p>
        </div>

        {/* <div className="mt-8 flex justify-between items-center">
          <button
          disabled={isEditing}
            onClick={handleEditProfile}
            className="bg-baseGreen text-white py-2 px-4 rounded-lg shadow-md hover:bg-orange-700 transition-colors duration-300 flex items-center"
          >
            <FaUserEdit className="mr-2" /> Edit Profile
          </button>
        </div> */}
      </div>

      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Edit Profile
            </h2>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-baseGreen"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Current Password
              </label>
              <input
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-baseGreen"
              />
            </div>
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                New Password
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-baseGreen"
              />
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setIsEditing(false)}
                className="bg-gray-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-gray-600 transition-colors duration-300 mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveChanges}
                className="bg-baseGreen text-white py-2 px-4 rounded-lg shadow-md hover:bg-orange-700 transition-colors duration-300"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {isAddingCard && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">
              Add Payment Card
            </h2>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Card Number
              </label>
              <input
                type="text"
                value={cardNumber}
                onChange={(e) => setCardNumber(e.target.value)}
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-baseGreen"
                placeholder="1234 5678 9012 3456"
              />
            </div>
            <div className="mb-4 flex space-x-4">
              <div className="w-1/2">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Expiry Date
                </label>
                <input
                  type="text"
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-baseGreen"
                  placeholder="MM/YY"
                />
              </div>
              <div className="w-1/2">
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  CVV
                </label>
                <input
                  type="text"
                  value={cvv}
                  onChange={(e) => setCvv(e.target.value)}
                  className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-baseGreen"
                  placeholder="123"
                />
              </div>
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setIsAddingCard(false)}
                className="bg-gray-500 text-white py-2 px-4 rounded-lg shadow-md hover:bg-gray-600 transition-colors duration-300 mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveCard}
                className="bg-baseGreen text-white py-2 px-4 rounded-lg shadow-md hover:bg-orange-700 transition-colors duration-300"
              >
                Save Card
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
